import { path } from 'ramda';

export const getHttpApi = path(['httpApi']);

export const getConfig = path(['config']);

export const getResults = path(['results']);
